import { Component, input } from "@angular/core";
import { FormArray, ReactiveFormsModule } from "@angular/forms";
import { Select } from "primeng/select";
import { FullWidthDirective } from "../../directives/full-width.directive";
import { TPipe } from "../../i18n/t.pipe";
import { FormRowComponent } from "../form-row/form-row.component";

@Component({
  standalone: true,
  selector: "app-child-ages",
  imports: [TPipe, ReactiveFormsModule, Select, FullWidthDirective, FormRowComponent],
  template: `
    @for (ctrl of ages().controls; track ctrl; let i = $index) {
      <app-form-row [label]="'Bambino {n}' | t: { n: i + 1 }">
        <p-select appFullWidth [options]="options()" [formControl]="$any(ctrl)" [placeholder]="'Età' | t"></p-select>
      </app-form-row>
    }
  `,
})
export class ChildAgesComponent {
  readonly ages = input.required<FormArray>();
  readonly options = input<{ label: string; value: number }[]>(
    Array.from({ length: 17 }, (_, i) => ({ label: String(i + 1), value: i + 1 })),
  );
}
